import { render, staticRenderFns } from "./TermsHome.vue?vue&type=template&id=50b8836e&scoped=true&"
import script from "./TermsHome.vue?vue&type=script&lang=ts&"
export * from "./TermsHome.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.scss?vue&type=style&index=0&id=50b8836e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8836e",
  null
  
)

export default component.exports